import { ButtonBase } from "@mui/material";
import EditInterest from "./EditInterest";
import ViewInterest from "./ViewInterest";
import NoSchedule from "./NoSchedule";
import { useContext, useEffect, useRef, useState } from "react";
import moment from "moment";
import ScheduleRateTab from "./ScheduleRateTab";
import { InterestRateContext } from ".";

const InterestRateTab = (props) => {
  const {intTabPos,setIntTabPos} = useContext(InterestRateContext);
    const {productData,numInterest,itemIdx} = props;
    let startDate = productData?.startDate ? moment(productData?.startDate).format("DD MMM YYYY").toUpperCase() : null;
    let endDate = productData?.endDate ? moment(productData?.endDate).format("DD MMM YYYY").toUpperCase() : null;
    const [editOpt,setEditopt] = useState(true);
    const interestTabRef = useRef(null);
    const editHandle = () => {
        setEditopt(true);
        if(interestTabRef.current){
          interestTabRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }
    const saveHandle = () => {
      if(interestTabRef.current){
        interestTabRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      setEditopt(false);

    }
    const changeToCurrent = () => {
      setIntTabPos(0);
    }
    const InterestTabTop = () => {
      if(interestTabRef.current){
        interestTabRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
    useEffect(()=>{
      if(productData.agentbonusinfo){
        setEditopt(false);
      }
    },[])
  return (
    <div>
               <div className={`switch_tab inline-block mt-[15px]`} ref={interestTabRef}>
                  <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex">
                      {
                          ['Current','Schedule'].map((tab,idx)=>{
                              return(
                                  <ButtonBase key={idx}>
                                  <span className={`switch ${intTabPos === idx && 'active'}`} onClick={()=>setIntTabPos(idx)}>{tab}</span>
                                  </ButtonBase>
                              )
                          })
                      }
                  </div>
              </div>
              <div className="border border-[#DEDEDE] mb-[40px]">
                <div className="p-[18px_23px] bg-[#F9FBFD] border-b border-[#DEDEDE]">
                  {
                    (productData?.agentbonusinfo?.schedule || intTabPos === 0) ?(
                    <div className="flex items-center max-[700px]:flex-col max-[700px]:items-start max-[700px]:gap-[25px]">
                      <div className="mr-[35px] rounded-[6px] min-w-[100px] bg-white p-[12px] pb-[6px]">
                        <h3 className="text-[rgba(38,50,56,0.7)] font-[500] text-[13px]">{itemIdx ? 'High Tier' : 'Low Tier'}</h3>
                        <span className="inline-block text-[25px] font-[800] text-[#263238]">
                          {productData?.interest}%
                        </span>
                      </div>
                      <div className="flex-[1]">
                      <div>
                        <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px] flex items-center min-w-[257px]">
                          <img src="/images/fi_calendar.svg" alt="calendar" className="mr-[5px]"/>
                          Available from: <strong className="ml-[5px] font-[600]">{startDate}
                          <span className="mx-[6px]">to</span>
                              {endDate ? endDate : 'Further Notice'}</strong>
                        </p>
                        <p className="text-[12px] mb-[3px] flex items-center min-w-[257px]">
                            <img src="/images/fi_dollar.svg" alt="calendar" className="mr-[5px]"/>
                            Min. Loan: <strong className="ml-[5px] font-[600]">{productData?.minimum_loan_amount > 0 ? '$' + parseInt(productData?.minimum_loan_amount) : 'No min. loan required'} {productData?.admin_fee_status === "1" && `else + admin fee $${parseInt(productData?.admin_fee)}`}</strong>
                        </p>
                        <div className="">
                          <p className="text-[12px] mb-[3px] max-[600px]:mb-[5px]">{productData?.remarks1.substring(0,100)}{productData?.remarks1.length>50 && '...'}</p>
                          <p className="text-[12px] mb-[0]">{productData?.remarks2.substring(0,100)}{productData?.remarks2.length>50 && '...'}</p>
                        </div>
                      </div>
                    </div>
                      {
                        intTabPos ?
                        <div className="font-[700] text-[13px] p-[8px_20px] bg-white rounded-[4px] text-[#FF0010] relative bottom-[10px] border border-[#E1E1E1]">
                          <span>Ohhto’s Changes</span>
                        </div> :null
                      }
                    </div>
                    ):(
                      <div className="text-center py-[20px]">
                        <h2 className="text-[#333333] text-[17px] font-[700] mb-[7px]">Oh oh! product don’t have any schedules </h2>
                        <p className="font-[500] text-[12px] text-[#5F7585]">Seems like the product don’t have any schedules now.</p>
                      </div>
                    )
                  }
                </div>
                {
                  !intTabPos ?
                  editOpt ? <EditInterest saveHandle={saveHandle} product={productData} /> : <ViewInterest itemIdx={itemIdx} product={productData.agentbonusinfo} editHandle={editHandle} />
                  : <ScheduleRateTab itemIdx={itemIdx} InterestTabTop={InterestTabTop} product={productData} changeToCurrent={changeToCurrent} />
                }
              </div>
    </div>
  )
};

export default InterestRateTab;
